import React, { Component } from "react";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import axios from "axios";
import * as appConst from "../../Common/constants";
import { connect } from "react-redux";
import { Dropdown } from "primereact/dropdown";

class PatientList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patients: [],
      spinnerClass: "collapse",
      dataClass: "",
      dummy: { _id: "NA" },
      status: "Active"
    };
  }

  componentDidMount() {
    this.loadData("Active");
  }

  loadData(st) {
    var obj = { status: st };
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +

        "/patientFilter",
        obj
      )
      .then(response => {
        this.setState({ patients: response.data });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  onGridReady = params => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  };

  render() {
    return (
      <>
        <h5 align="center">Patient List</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="ag-theme-blue" style={this.getHeight()}>
            <div>
              <button
                onClick={this.onEditClick}
                className="btn btn-primary btn-sm mb-2"
              >
                Edit Patient
              </button>
            </div>
            <AgGridReact
              rowData={this.state.patients}
              pagination={true}
              enableSorting={true}
              enableFilter={true}
              onGridReady={this.onGridReady}
              paginationAutoPageSize={true}
            //paginationPageSize={10}
            >
              <AgGridColumn
                field="pno"
                headerName="Reg No"
                width={200}
                checkboxSelection
                filter={false}
                resizable
              />
              <AgGridColumn
                field="name"
                headerName="Name"
                width={200}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="age"
                headerName="Age"
                width={70}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="gender"
                headerName="Gender"
                width={90}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="phone"
                headerName="Phone"
                width={150}
                sortable
                resizable
                filter
              />
              <AgGridColumn
                field="regdate"
                headerName="Reg Date"
                width={110}
                sortable
                resizable
                filter
                valueFormatter={this.dateFormatter}
              />
            </AgGridReact>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 175;
    return { height: hgt + "px" };
  }

  dateFormatter(params) {
    if (params.value !== null) {
      var arr = params.value.split("-");

      if (parseInt(arr[0]) != 1)
        return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
      else
        return "";
    }
  }

  onEditClick = e => {
    const selectedNodes = this.gridApi.getSelectedNodes();
    if (selectedNodes.length > 0)
      this.props.onClick("AddEdit", selectedNodes[0].data);
    else {
      this.growl.show({
        severity: "error",
        summary: "Error",
        detail: "Select Patient !!"
      });
    }
  };
}

export default PatientList;
